export const DEFAULT_RISK_VISIBLE_TAB_IDS = ['matrix', 'control', 'event-map', 'list'];
export const DEFAULT_INTERNAL_VISIBLE_DRAFT_GROUPS = ['资金管理', '销售与收款', '预算管理', '财务报告', '税务管理', '结算与金融业务'];
export const DEFAULT_INTERNAL_VISIBLE_MODES = ['draft'];
export const DEFAULT_INTERNAL_DRAFT_EVAL_PERMISSION = 'edit';
export const INTERNAL_CONTROL_MODE_OPTIONS = [
  { id: 'chain', label: '产业链环节窗口' },
  { id: 'draft', label: '底稿子流程窗口' },
];
export const INTERNAL_DRAFT_EVAL_PERMISSION_OPTIONS = [
  { id: 'view', label: '仅查看' },
  { id: 'edit', label: '编辑' },
  { id: 'manage', label: '管理' },
];

export function normalizeStringArray(list) {
  if (!Array.isArray(list)) return [];
  return Array.from(new Set(list.map((item) => String(item || '').trim()).filter(Boolean)));
}

export function parseTempScopeConfig(raw) {
  if (!raw || typeof raw !== 'object') return {};
  return raw;
}

export function buildTempScopeConfig({
  riskVisibleTabs,
  riskEditableDepartments,
  internalVisibleDraftGroups,
  internalVisibleModes,
  internalDraftEvalPermission,
  templateId = '',
  templateName = '',
  auditDeptPath = null,
}) {
  const nextInternalModes = normalizeStringArray(internalVisibleModes).filter((mode) => ['chain', 'draft'].includes(mode));
  const nextDraftEvalPermission = ['view', 'edit', 'manage'].includes(String(internalDraftEvalPermission || '').trim())
    ? String(internalDraftEvalPermission || '').trim()
    : DEFAULT_INTERNAL_DRAFT_EVAL_PERMISSION;
  const out = {
    risk: {
      visibleTabs: normalizeStringArray(riskVisibleTabs),
      editableDepartments: normalizeStringArray(riskEditableDepartments),
    },
    internalControl: {
      visibleDraftGroups: normalizeStringArray(internalVisibleDraftGroups),
      visibleModes: nextInternalModes.length ? nextInternalModes : [...DEFAULT_INTERNAL_VISIBLE_MODES],
      draftEvalPermission: nextDraftEvalPermission,
    },
  };
  const normalizedAuditDeptPath = auditDeptPath && typeof auditDeptPath === 'object'
    ? {
        deptL1: String(auditDeptPath.deptL1 || '').trim(),
        deptL2: String(auditDeptPath.deptL2 || '').trim(),
        deptL3: String(auditDeptPath.deptL3 || '').trim(),
      }
    : null;
  const hasAuditDeptPath = Boolean(
    normalizedAuditDeptPath &&
    (normalizedAuditDeptPath.deptL1 || normalizedAuditDeptPath.deptL2 || normalizedAuditDeptPath.deptL3)
  );
  if (templateId || templateName || hasAuditDeptPath) {
    out.meta = {
      templateId: String(templateId || '').trim(),
      templateName: String(templateName || '').trim(),
    };
    if (hasAuditDeptPath) out.meta.auditDeptPath = normalizedAuditDeptPath;
  }
  return out;
}

export function buildTempUserDraftFromScope(scope, auditGroup) {
  const visibleTabs = normalizeStringArray(scope?.risk?.visibleTabs);
  const editableDepartments = normalizeStringArray(scope?.risk?.editableDepartments);
  const visibleDraftGroups = normalizeStringArray(scope?.internalControl?.visibleDraftGroups);
  const visibleModes = normalizeStringArray(scope?.internalControl?.visibleModes).filter((mode) => ['chain', 'draft'].includes(mode));
  const internalDraftEvalPermission = ['view', 'edit', 'manage'].includes(String(scope?.internalControl?.draftEvalPermission || '').trim())
    ? String(scope?.internalControl?.draftEvalPermission || '').trim()
    : DEFAULT_INTERNAL_DRAFT_EVAL_PERMISSION;
  return {
    riskVisibleTabs: visibleTabs.length ? visibleTabs : [...DEFAULT_RISK_VISIBLE_TAB_IDS],
    riskEditableDepartments: editableDepartments.length ? editableDepartments : (auditGroup ? [auditGroup] : []),
    internalVisibleDraftGroups: visibleDraftGroups.length ? visibleDraftGroups : [...DEFAULT_INTERNAL_VISIBLE_DRAFT_GROUPS],
    internalVisibleModes: visibleModes.length ? visibleModes : [...DEFAULT_INTERNAL_VISIBLE_MODES],
    internalDraftEvalPermission,
  };
}

export function buildNextEditableDepartments(riskEditableDepartments, auditGroup) {
  const normalized = normalizeStringArray(riskEditableDepartments);
  return normalized.length ? normalized : [auditGroup];
}
